import apiClient from './apiClient';

export const getAllBestellungen = async (params = {}) => {
  const response = await apiClient.get('/bestellungen/alle', { params });
  return response.data;
};

export const getBestellungenByProjekt = async (projektId) => {
  const response = await apiClient.get(`/bestellungen/projekte/${projektId}`);
  return response.data;
};

export const createBestellung = async (projektId, data) => {
  const response = await apiClient.post(`/bestellungen/projekte/${projektId}`, data);
  return response.data;
};

export const getBestellungById = async (id) => {
  const response = await apiClient.get(`/bestellungen/${id}`);
  return response.data;
};

export const updateBestellung = async (id, data) => {
  const response = await apiClient.patch(`/bestellungen/${id}`, data);
  return response.data;
};

export const getBestellVorschau = async (id) => {
  const response = await apiClient.get(`/bestellungen/${id}/vorschau`);
  return response.data;
};

export const sendeBestellung = async (id) => {
  const response = await apiClient.post(`/bestellungen/${id}/senden`);
  return response.data;
};

export const storniereBestellung = async (id) => {
  const response = await apiClient.post(`/bestellungen/${id}/stornieren`);
  return response.data;
};

export const updateLieferung = async (bestellungId, positionId, mengeGeliefert) => {
  const response = await apiClient.patch(`/bestellungen/${bestellungId}/positionen/${positionId}`, { mengeGeliefert });
  return response.data;
};

export const getBestellungenByLieferant = async (lieferantId) => {
  const response = await apiClient.get(`/bestellungen/lieferant/${lieferantId}`);
  return response.data;
};
